import { Action, createAction, createReducer, createSelector, on, props } from '@ngrx/store';
import { IntColumn, TableResultDto } from '../../shared/models/interface';

import { IAppUtilities, IDataFilterSave, IDataGrid } from './../../shared/models/dataGrid';
import { IVisorState } from 'app/visor/shared/models/mapModels';
import { getVisorState } from '@leafletStore/selectors/config-leaflet.selector';

export const getGridState = createSelector(getVisorState, (state: IVisorState) => state.utilities);

export class UtilitiesStore {
    private state: IAppUtilities = {
        DataGrid: {
            colId: '',
            modalOpened: false,
            colType: '',
            tableResultDto: {
                data: {
                    data: [],
                    adjust: true,
                    autoEmptyRow: false,
                    autoHeight: false,
                    autoWidth: false,
                    columns: [],
                    typeServer: '',
                    editable: false,
                    multiselection: false,
                    tooltip: false,
                    resizable: false,
                    keyNavigation: false,
                    rowHeight: 30,
                    pageSize: 20,
                    selection: 'cell',
                    originalData: [],
                },
                message: '',
                state: '',
            },
        },
        IDataFilterSave: {
            config: [],
        },
    };
    private SET_DATA_GRID = '[DataGrid] Cambiar datos del grid';
    private ACTIVATE_FILTER = '[DataGrid] Activar filtro';
    private CHANGE_GRID_FILTER_DATA = '[DataGrid] Cambiar los datos del filtro';
    private SET_GRID_DTO_COLUMS = '[DataGrid] Cambiar las columnas del dataGrid';
    private SET_TABLE_RESULT_DTO = '[DataGrid] Cambiar toda la informacion del grid';
    private SAVE_DATA_FILTER_GRID = '[DataGrid] guarda los filtros de los grids por id';
    private SET_DATA_TABLE_VALUES = '[DataGrid] Asignar o cambiar los valores que tiene la tabla';
    private SET_ORIGINAL_DATA = '[DataGrid] Asignar valores por defecto';

    activateFilter = createAction(this.ACTIVATE_FILTER, props<{ modalOpened: boolean }>());
    setOriginalData = createAction(this.SET_ORIGINAL_DATA, props<{ originalData: any[] }>());
    setDataGrid = createAction(this.SET_DATA_GRID, props<{ colId; colType; tableResultDto; modalOpened }>());
    setDataTableValues = createAction(this.SET_DATA_TABLE_VALUES, props<{ data: any[] }>());
    setTableResultDto = createAction(this.SET_TABLE_RESULT_DTO, props<{ tableResultDto: TableResultDto }>());
    saveDataFilter = createAction(this.SAVE_DATA_FILTER_GRID, props<{ dataFilterSave: IDataFilterSave }>());
    setGridDtoColumns = createAction(this.SET_GRID_DTO_COLUMS, props<{ columns: IntColumn[] }>());
    changeGridFilterData = createAction(this.CHANGE_GRID_FILTER_DATA, props<{ data: any }>());

    ReducerUtilities = createReducer(
        this.state,
        on(
            this.setDataGrid,
            (state, { colId, colType, tableResultDto, modalOpened }: IDataGrid): IAppUtilities => ({
                ...state,
                DataGrid: {
                    colId,
                    colType,
                    tableResultDto,
                    modalOpened,
                },
            })
        ),
        on(
            this.changeGridFilterData,
            (state, { tableResultDto }: any): IAppUtilities => {
                const stateAux = JSON.parse(JSON.stringify(state)) as IAppUtilities;
                const aux = JSON.parse(JSON.stringify(stateAux.DataGrid.tableResultDto.data.columns)) as IntColumn[];
                aux.forEach((x) => {
                    if (!x.filter) {
                        x.filter = {
                            value1: '',
                            value2: '',
                            operator1: '',
                            operator2: '',
                            condition: '',
                            type: x.type,
                        };
                    }
                });
                stateAux.DataGrid.tableResultDto.data.columns = aux;
                return {
                    ...stateAux,
                    DataGrid: {
                        ...stateAux.DataGrid,
                        tableResultDto,
                    },
                };
            }
        ),
        on(
            this.setGridDtoColumns,
            (state, { columns }): IAppUtilities => {
                const newState = {
                    ...state,
                    DataGrid: {
                        ...state.DataGrid,
                        tableResultDto: {
                            ...state.DataGrid.tableResultDto,
                            data: {
                                ...state.DataGrid.tableResultDto?.data,
                                columns,
                            },
                        },
                    },
                };
                return newState;
            }
        ),
        on(this.setTableResultDto, (state, { tableResultDto }): IAppUtilities | any => ({
            ...state,
            DataGrid: {
                action: 'setDatatableResultDto',
                ...state.DataGrid,
                tableResultDto,
            },
        })),
        on(
            this.saveDataFilter,
            (state, { dataFilterSave }): IAppUtilities => ({
                ...state,
                IDataFilterSave: {
                    config: dataFilterSave,
                },
            })
            // return IDataFilterSave;
        ),
        on(
            this.activateFilter,
            (state, { modalOpened }): IAppUtilities => ({
                ...state,
                DataGrid: {
                    ...state.DataGrid,
                    modalOpened,
                },
            })
        ),
        on(this.setDataTableValues, (state, { data }): IAppUtilities | any => {
            if (!data || data.length == 0) {
                return state;
            }

            return {
                ...state,
                DataGrid: {
                    action: 'asignarValoresTabla',
                    ...state.DataGrid,
                    tableResultDto: {
                        ...state.DataGrid.tableResultDto,
                        Data: {
                            ...state.DataGrid.tableResultDto?.Data,
                            data,
                        },
                    },
                },
            };
        }),
        on(
            this.setOriginalData,
            (state, { originalData }): IAppUtilities => {
                if (!originalData || originalData.length == 0) {
                    return state;
                }
                return {
                    ...state,
                    DataGrid: {
                        ...state.DataGrid,
                        tableResultDto: {
                            ...state.DataGrid.tableResultDto,
                            Data: {
                                ...state.DataGrid.tableResultDto?.Data,
                                originalData,
                            },
                        },
                    },
                };
            }
        )
    );

    reducerUtilities = (state = this.state, action: Action): IAppUtilities => this.ReducerUtilities(state, action);
}

export class AppUtilitiesSelectors {
    getFilterGridState = createSelector(getGridState, (state: IAppUtilities) => state.DataGrid);
    getFilterGridStateSave = createSelector(getGridState, (state: IAppUtilities) => state.IDataFilterSave);
    getTableResultDto = createSelector(this.getFilterGridState, (state: IDataGrid) => state.tableResultDto);
    getGridDto = createSelector(this.getFilterGridState, (state: IDataGrid) => state.tableResultDto.data);
    getGridDtoColumns = createSelector(this.getFilterGridState, (state: IDataGrid) => state.tableResultDto.data.columns);
    getFilterIsOpen = createSelector(this.getFilterGridState, (state: IDataGrid) => state.modalOpened);
    getDataGridValues = createSelector(this.getFilterGridState, (state: IDataGrid) => state?.tableResultDto?.data);
    getDataSaveConfig = createSelector(this.getFilterGridStateSave, (state: IDataFilterSave) => state?.config);
    getOriginalDataGridValues = createSelector(this.getFilterGridState, (state: IDataGrid) => state.tableResultDto?.data?.originalData);
}
export { IAppUtilities, IDataGrid };
